import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import commonHolidayMoadl from './common-holiday-modal';
import { holidayList, holidayDelete } from 'api/Attendance';
export default {
  components: {
    commonHolidayMoadl: commonHolidayMoadl
  },
  data: function data() {
    return {
      // 编辑或新建
      isEdit: false,
      page: {
        page: 1,
        page_size: 20,
        total: 0
      },
      tableLoading: false,
      tableData: []
    };
  },
  created: function created() {
    this.getTableData();
  },
  methods: {
    // 分页相关
    handleSizeChange: function handleSizeChange(v) {
      this.page.page = 1;
      this.page.page_size = v;
      this.getTableData();
    },
    handleCurrentChange: function handleCurrentChange(v) {
      this.page.page = v;
      this.getTableData();
    },
    // 打开新建或编辑弹窗
    openHolidayModal: function openHolidayModal(status, row) {
      var _this = this;
      this.isEdit = status;
      this.$refs.modal.visible = true;
      // 编辑获取详情
      if (status) {
        this.$nextTick(function () {
          _this.$refs.modal.holidayDetail(row.id);
        });
      }
    },
    // 获取表格数据
    getTableData: function getTableData() {
      var _this2 = this;
      this.tableLoading = true;
      holidayList(this.page).then(function (res) {
        var _res$data = res.data,
          items = _res$data.items,
          total = _res$data.total;
        _this2.tableData = items || [];
        _this2.page.total = total;
      }).finally(function () {
        return _this2.tableLoading = false;
      });
    },
    // 删除
    handleDel: function handleDel(row) {
      var _this3 = this;
      this.$confirm(this.$t('1846'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        confirmButtonClass: 'el-button--mini',
        cancelButtonClass: 'el-button--mini',
        type: 'warning'
      }).then(function () {
        holidayDelete(row).then(function () {
          return _this3.getTableData();
        });
      });
    }
  }
};